import { DEFAULT_ISO_DATE_FORMAT, format } from '@shared/utils'
import dayjs from 'dayjs'

export const getMonthLabel = (i: number, locale: string) =>
  dayjs().locale(locale).localeData().months()[i]

export const isoFirstDayOfMonth = (y: number, mIndex0: number) =>
  format(
    dayjs(`${y}-${String(mIndex0 + 1).padStart(2, '0')}-01`),
    DEFAULT_ISO_DATE_FORMAT
  )

export const isEditableMonth = (monthIndex0: number, selectedYear: number) => {
  const now = dayjs()
  const yNow = now.year()
  const mNow = now.month()
  if (selectedYear < yNow) return true
  if (selectedYear > yNow) return false
  return monthIndex0 <= mNow
}
